<template>

<div class="psicoHistory">
    
    <!-- Botón flotante -->
    
    <div class="container my-4" v-show="!loadStart">
        <h4 class="p-3 mb-2 pt-0 text-blue fw-light fst-italic text-start">Apuntes:</h4>
        <a class="btn-add p-3 mb-2 pt-0 pointer" @click="this.ref = ''; this.note = ''; this.disabled = true; openModal()"><i class="las la-plus text-green"></i> <span class="p-2 pt-0 pb-0">Agregar Apunte</span></a>
           
        <div class="card mt-2 mx-auto" v-show="notes.length == 0 && !hasNotes" style="max-width: 600px">
            <div class="card-body p-2 no-turns d-flex justify-content-center align-items-center text-center">
                <div>
                    <h5>No tienes apuntes craedos para este usuario.</h5>
                    <img src="@/assets/imgs/edit-animate.webp" class="w-25 mx-auto" />
                    
                    <h6 class="fst-italic">Usa estas notas para registrar observaciones de tus sesiones con el consultante. Ten en cuenta que el consultante no tendrá acceso a esta información.</h6>
                </div>
            </div>
        </div>
        <ul class="timeline" v-show="notes.length > 0">
            <li v-for="n in notes" :key="n.id">
                <a class="badge rounded-pill date">{{n.date}}</a>
                <a class="float-right" @click="this.ref = n.id; this.note = n.note; this.disabled = true; openModal()">Editar</a>
                <p>{{n.note}}</p>
            </li> 
        </ul>


    

    <!-- Modal nueva nota -->
    <div class="modal fade" id="modalNuevaNota" tabindex="-1" aria-labelledby="modalNuevaNotaLabel" aria-hidden="true" data-bs-backdrop="false" data-bs-keyboard="false" style="z-index:1000000">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title" id="modalNuevaNotaLabel">Nueva nota</h5>
            <button type="button" class="btn-close" @click="closeModal()" aria-label="Cerrar"></button>
            </div>
            <div class="modal-body">
            <div class="mb-3">
                <label for="note" class="form-label">Nota</label>
                <textarea class="form-control" id="note" name="note" rows="5" cols="10" required v-model="note"></textarea>
            </div>
            <!-- Podés agregar más campos si querés -->
            </div>
            <div class="modal-footer">
            <button type="submit" class="btn btn-primary w-50 p-3 pb-2 pt-2" @click="saveNote()" :disabled="disabledBtn"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span> Guardar nota</button>
            </div>
        </div>
        </div>
    </div>
    </div>

    <div class="mx-auto position-fixed bottom-0 end-0 start-0 end-0 p-0 pt-3 pb-3" style="z-index: 118; width: fit-content; margin-bottom: 0px;">
        <div id="toastcontainerNotes" class="w-25">
        </div>
    </div>
</div>
</template>
<script>
import axios from "axios";
import { Toast } from 'bootstrap';
import { Modal } from "bootstrap";
export default {    
    name: "psicoHistory",
    props: ['userId', 'consId'],
    data(){
        return{
            note: '',
            localZone: '',
            edit: false,
            ref: '',
            next: 0,
            notes: [],
            loadStart: true,
            disabled: false,
            disabledBtn: false,
            loading: false,
            modal: '',
            hasNotes: false
        }
    },
    mounted: function () {  
        this.localZone =  moment.tz.guess();
        this.findNotes();
    },
    unmounted: function () {
        try{
            this.modal.hide();
        }catch(e){

        }
    },
    methods:{
        openModal(){
            var modal = new Modal(document.querySelector('#modalNuevaNota'))
            this.modal = modal;
            modal.show()
        },
        closeModal(){
            this.modal.hide();
            this.disabled = false;
            this.disabledBtn = false;
            this.loading = false;
        },
        async findNotes(){
            var payload = {
                action: 'find-psico-notes',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.userId,
                consId: this.consId,
                next: this.next,  
            } 
            await axios.post('/index.php', payload).then(result => {  
                this.loadStart = false;
                let sum = 0;
                Object.keys(result.data).forEach(key => {
                    this.hasNotes = true;
                    this.notes.push(result.data[sum]); 
                    sum++;                        
                });
                this.next = this.next+10;             
            })
            .catch(error => {
               
            })         

        },
        async saveNote(){
            if(this.note == ''){
                this.errorText = 'No hay texto para agregar la nota.';
                this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainerNotes').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }		
                return
            }
            var payload = {
                action: 'save-psico-notes',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                timezone: this.localZone,
                dataReceiver: this.userId,
                consId: this.consId,
                ref: this.ref,  
                note: this.note
            } 
            this.disabledBtn = true;
            this.loading = true;
            await axios.post('/index.php', payload).then(result => {  
                this.disabledBtn = false;
                this.loading = false;
                if(result.data.status == '200'){
                    this.notes = [];
                    this.next = 0;
                    this.findNotes();
                    if(this.ref == ''){
                        this.errorText = 'Nota agregada.';
                    }else{
                        this.errorText = 'Nota editada.';
                    }
                    this.toastBg = 'bg-info';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainerNotes').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }
                    this.closeModal();		
                }else{
                    if(result.data.status == '400'){
                        if(result.data.error == 'E2'){
                            this.errorText = 'La nota no puede estar vacia.';
                        }else if(result.data.error == 'E3'){
                            this.errorText = 'La nota es demasiado corta.';
                        }else if(result.data.error == 'E4'){
                            this.errorText = 'La nota es demasiado larga.';
                        }
                        this.toastBg = 'bg-danger';
                        this.toastColor = 'text-dark';
                        this.toastNumber++;
                        var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                        try{
                            document.querySelector('#toastcontainerNotes').insertAdjacentHTML("afterend", t);
                            var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                            var bsAlert = new Toast(myAlert);//inizialize it
                            bsAlert.show();//show it
                        }catch(e){

                        }
                    }
                }              
            })
            .catch(error => {
                this.disabledBtn = false;
                this.loading = false;
            })         

        }
    }
}
</script>
<style scoped>
.psicoHistory ul.timeline {
    list-style-type: none;
    position: relative;
}
.psicoHistory ul.timeline:before {
    content: ' ';
    background: #d4d9df;
    display: inline-block;
    position: absolute;
    left: 152px;
    width: 2px;
    height: 100%;
    z-index: 400;
}
.psicoHistory ul.timeline > li {
    margin: 15px 0;
    padding-left: 136px;
}
.psicoHistory ul.timeline > li:before {
    content: ' ';
    background: #004193;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid #f5f5f5;
    left: 146px;
    width: 15px;
    height: 15px;
    z-index: 400;
}
.psicoHistory .btn-add{
  display: flex;
  align-items: center;
  color: #212529;
  text-decoration: none;
  cursor: pointer !important;
}
.psicoHistory .btn-add .la-plus {
    width: 30px;
    height: 30px;
    font-size: 24px;
    padding: 0;
    border-radius: 50%; 
    background: #00c7a2 ;
    color: #fff;
    text-decoration: none;
    padding: 3px;
}
.psicoHistory a {
    position: relative;
    display: inline-block;
    top: -6px;
    font-size: 0.9rem;
    color: #004193 !important;
    text-decoration: none; 
}
.psicoHistory a.date {
    color: #004193 !important;
    background-color: #caf3eb !important;
    border-color: #caf3eb !important;
    left: -190px;
    font-size: 0.8rem;
    line-height: 1;
}
.psicoHistory .float-right {
    float: left !important;
    font-size: 0.7rem;
    cursor: pointer !important;
    top: -1px;
}
.psicoHistory a.float-right:hover {
    text-decoration: underline;
}
.psicoHistory li p {
    font-size: 0.9rem;
    font-weight: 400;
    line-height: 1.3;
    margin-top: -5px;
    color: #212529;
}
@media screen and (max-width: 720px) {
    .psicoHistory .btn-float {
        bottom: 90px;
        right: 12px;
        width: 45px;
        height: 45px;
    }
    .psicoHistory ul.timeline:before {
        left: 22px;
    }
    .psicoHistory ul.timeline > li {
        padding-left: 8px;
    }
    .psicoHistory ul.timeline > li:before {
        left: 15px;
    }
    .psicoHistory a.date {
        left: 0;
    }
    .psicoHistory .float-right {
        float: right !important;
    }
}
</style>